import axios from '../request/http';

const integral = {
    // 积分事项分类列表V2
    getImVillageScoreItemCategoryListV2(params) {
        return axios.get("/hemei-admin/village/score/item/getImVillageScoreItemCategoryListV2", { params });
    },
    // 查询积分分类列表
    getImVillageScoreItemCategoryListV1(params) {
        return axios.get("/hemei-admin/village/score/item/getImVillageScoreItemCategoryListV1", { params });
    },
    // 新建乡村积分事项分类
    addVillageScoreItemCategory(data) {
        return axios.post("/hemei-admin/village/score/item/addVillageScoreItemCategory", data);
    },
    // 编辑乡村积分事项分类名称
    editVillageScoreItemCategoryName(params) {
        return axios.get("/hemei-admin/village/score/item/editVillageScoreItemCategoryName", { params });
    },
    // 检查积分事项是否可以删除
    checkScoreItemDeleteStatus(params) {
        return axios.get("/hemei-admin/village/score/item/checkScoreItemDeleteStatus", { params });
    },
    // 更新积分事项分类状态
    updateVillageScoreItemCategoryStatus(data) {
        return axios.post("/hemei-admin/village/score/item/updateVillageScoreItemCategoryStatus", data);
    },
    // 检查积分分类是否可以修改状态
    checkUpDownShelvesStatus(data) {
        return axios.post("/hemei-admin/village/score/item/checkUpDownShelvesStatus", data);
    },
    // 查询某一乡村没有创建积分规则的积分事项分类
    getNotItemCategoryList(params) {
        return axios.get("/hemei-admin/village/score/item/getNotItemCategoryList", { params });
    },
    // 查询积分分类事项
    getScoreItemByCategoryId(params) {
        return axios.get("/hemei-admin/village/score/item/getScoreItemByCategoryId", { params });
    },
}

export default integral;


// WEBPACK FOOTER //
// ./src/api/integral.js